<script setup>
  import SearchIcon from '@/assets/icons/layout/search.svg'
  import { vOnClickOutside } from '@vueuse/components'
  import { onKeyStroke } from '@vueuse/core'
  import { useI18n } from 'vue-i18n'

  import { ref } from 'vue'

  const { t } = useI18n()
  const searchOpened = ref(false)
  const inputValue = ref('')

  function toggleSearch() {
    searchOpened.value = !searchOpened.value
  }

  function closeSearch() {
    searchOpened.value = false
  }

  onKeyStroke('Escape', e => {
    e.preventDefault()
    closeSearch()
  })
</script>

<template>
  <div
    v-on-click-outside="closeSearch"
    class="header-search"
    :class="{ 'search-opened': searchOpened }"
  >
    <div class="search-icon">
      <button
        class="search-icon-button"
        type="button"
        aria-label="Toggle Search"
        @click="toggleSearch"
      >
        <SearchIcon />
      </button>
    </div>
    <form class="search-form" @submit.prevent>
      <input
        v-model="inputValue"
        :placeholder="t('headerMenu.searchPlaceholder')"
        :class="{ 'input-visible': searchOpened }"
        type="text"
        :aria-label="t('headerMenu.searchPlaceholder')"
      />
    </form>
  </div>
</template>

<style lang="scss" scoped>
  .header-search {
    display: flex;
    align-items: center;
    width: 40px;
    height: 40px;
    border-radius: 20px;
    background-color: transparent;
    overflow: hidden;
    transition: width 0.3s ease;
    color: var(--fm-ui-layout-header-search-icon-color);

    &.search-opened {
      width: 240px;
      box-shadow: 0 4px 4px 0 #0000000d;
      background: var(--fm-ui-layout-header-search-opened-background-color);
    }
  }

  .search-icon {
    cursor: pointer;
    min-width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    z-index: 2;
  }

  .search-icon-button {
    @include resetButton;
    @include focusRing;
  }

  .search-opened {
    .search-icon {
      color: var(--fm-ui-layout-header-search-opened-icon-color);
    }
  }

  .search-form {
    flex-grow: 1;
    display: flex;
    align-items: center;
  }

  input {
    width: 0;
    padding: 0;
    border: none;
    background: transparent;
    font-size: 13px;
    transition:
      width 0.3s ease,
      padding 0.3s ease;
    color: var(--fm-ui-layout-header-search-opened-input-color);

    &::placeholder {
      color: var(--fm-ui-layout-header-search-opened-input-placeholder-color);
    }

    &.input-visible {
      width: 180px;
      padding: 0 10px;
    }

    &:focus {
      outline: none;
    }
  }
</style>
